import { KTIcon } from "../../../../../_metronic/helpers"
import { useWriteMessage } from "../WriteMessageProvider"

const ModalSendingHeader = () => {
  const { is_show, setVisible } = useWriteMessage()

  return (
    <div className='modal-header'>
      {/* begin::Modal title */}
      <h2 className='fw-bolder'>메시지 전송</h2>
      {/* end::Modal title */}

      {/* begin::Close */}
      <div
        className='btn btn-icon btn-sm btn-active-icon-primary'
        data-kt-users-modal-action='close'
        onClick={
          () =>{
            
          setVisible(false)
          }           
        }
        style={{cursor: 'pointer'}}
      >
        <KTIcon iconName='cross' className='fs-1' />
      </div>
      {/* end::Close */}
    </div>
  )
}

export {ModalSendingHeader}
